<template>
  <div class="componentRoot" style="overflow: hidden">
    <v-card class="pb-0 mb-1" flat style="flex-grow: 1; display: flex; flex-direction: column">
      <v-table
        style="overflow: auto; flex-grow: 1"
        :style="{
          'background-color': backgroundColor
            ? backgroundColor
            : 'transparent !important',
        }"
        fixed-header
        :class="{ 'pa-4': !hidePadding, 'pa-0': hidePadding }"
        ref="my-table"
      >
        <slot />
      </v-table>

      <v-container class="py-0 pa-2" 
      v-if="!hideFooter">
        <v-row>
          <v-col
            :cols="countCols"
            class="pa-0 pl-2"
            style="
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
            "
          >
            <p v-if="total">
              <i>{{ $t("basics.count") }}: {{ total }}</i>
            </p>
          </v-col>

          <v-col :cols="pageCols" class="pa-0">
            <v-pagination
              class="mb-4 mt-2"
              :length="numPages"
              v-model="currPage"
            ></v-pagination>
          </v-col>

          <v-col :cols="countCols" v-if="!isMobile" class="pa-0">
            <v-select
              v-if="showPageSize"
              :label="$t('basics.pageSize')"
              :items="sizes"
              variant="outlined"
              v-model="pageSize"
              class="hideDetails py-0"
            ></v-select>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "tableComponent",

  props: [
    "numPages",
    "showPageSize",
    "customCounter",
    "total",
    "hidePadding",
    "hideFooter",
    "resetPage",
    "backgroundColor",
  ],
  emits: ["switchPage", "switchPageSize"],

  data() {
    return {
      currPage: 1,

      pageSize: "20",
      sizes: this.customCounter ? this.customCounter : [25, 50, 100, "All"],
    };
  },

  watch: {
    resetPage() {
      this.currPage = 1;
    },
    currPage() {
      this.$emit("switchPage", this.currPage);

      var table = this.$refs["my-table"];
      var wrapper = table.$el.querySelector("div.v-table__wrapper");

      // Scroll to the top of the table
      wrapper.scrollTop = 0;
      wrapper.scrollTo(0, 0);
    },
    pageSize() {
      this.currPage = 1;

      if (this.sizes.indexOf(this.pageSize) == this.sizes.length - 1) {
        this.$emit("switchPageSize", 50000);
      } else {
        this.$emit("switchPageSize", this.pageSize);
      }
    },
  },

  computed: {
    countCols() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return 3;
        case "sm":
          return 3;
        case "md":
          return 2;
        case "lg":
          return 2;
        case "xl":
          return 2;
        case "xxl":
          return 2;
        default:
          return 2;
      }
    },
    pageCols() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return 9;
        case "sm":
          return 9;
        case "md":
          return 10;
        case "lg":
          return 8;
        case "xl":
          return 8;
        case "xxl":
          return 8;
        default:
          return 8;
      }
    },
    isMobile() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return true;
        case "sm":
          return true;
        case "md":
          return true;
        case "lg":
          return false;
        case "xl":
          return false;
        case "xxl":
          return false;
        default:
          return false;
      }
    },
  }
};
</script>
